export default "__VITE_ASSET__4762e3e6__"